import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldProtected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.83333 0.788V13.4547M11.1667 7.12133C11.1667 10.3936 7.59736 12.7736 6.29866 13.5313C6.15107 13.6174 6.07727 13.6604 5.97312 13.6827C5.89229 13.7001 5.77437 13.7001 5.69355 13.6827C5.5894 13.6604 5.5156 13.6174 5.36801 13.5313C4.06931 12.7736 0.5 10.3936 0.5 7.12133V3.93307C0.5 3.40006 0.5 3.13356 0.587174 2.90447C0.664183 2.70209 0.789322 2.52152 0.951772 2.37835C1.13566 2.21629 1.3852 2.12272 1.88427 1.93557L5.4588 0.595116C5.5974 0.543142 5.6667 0.517155 5.73799 0.506853C5.80122 0.497716 5.86544 0.497716 5.92868 0.506853C5.99997 0.517155 6.06927 0.543142 6.20786 0.595116L9.7824 1.93557C10.2815 2.12272 10.531 2.21629 10.7149 2.37835C10.8773 2.52152 11.0025 2.70209 11.0795 2.90447C11.1667 3.13356 11.1667 3.40006 11.1667 3.93307V7.12133Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShieldProtected;
